export default __webpack_public_path__ + "static/laptop-27a85c768ae86b5757f6c66e7f47b321.png";